import { constVarianteKeyErstanforderung, constVarianteKeyAenderung, constVarianteKeyAbmeldung, constVarianteKeySonderfall, constFTypeDropdown, constFTypeTextField } from "../../../../common/CommonConstants";
import { IFormField, IVariant } from "../../../../common/CommonTypes";

import * as commonCode from "../../../../common/components/request/RequestCommonCode";

// ============ ListNames =============
export const constLNMedien = "Medien";

export const constZyklusMaxWidthChar = 90;

export const apiEndpointSubmit =
  "https://medienantraege-backend-v2.azurewebsites.net/api/GetAntragRohrgefuehrteMedien?code=82-iw8AR8zDMnA-h5Luf64avp7HfMZ7EJQv1bajW07y9AzFuA-A55A==";
  // "https://medienantraege-backend.azurewebsites.net/api/GetAntragAnderungRohrgefuehrteMedien?code=-uurit2HMPJcDpO-EHX27x3XuIydfVnX8NGEtAaScy5aAzFu9N_DbQ==";
  // "https://medienantraege-backend.azurewebsites.net/api/GetAntragAnderungRohrgefuhrteMedien?code=DoGoVN1abYRXSNqYzuGPpIwZCzatghT7iUp2iIKQ/gxNo0AZ52gmVg==";
  // "https://inf-medienantragev2.azurewebsites.net/api/GetAntragAnderungRohrgefuhrteMedien?code=QwupRV6c2BcAxhv3xv4kktjvR97xtk9wykOZRcv27uQCjNGPxBXQNA==";
  // "http://localhost:7071/api/GetAntragAnderungRohrgefuehrteMedien";


export const VariantenRM: IVariant[] = [
  { Key: constVarianteKeyErstanforderung, RadioButtonLabel: constVarianteKeyErstanforderung, AbschnittTitel: "Abnahme Erstanforderung" },
  { Key: constVarianteKeyAenderung, RadioButtonLabel: constVarianteKeyAenderung, AbschnittTitel: "Abnahmeänderung" },
  { Key: constVarianteKeyAbmeldung, RadioButtonLabel: constVarianteKeyAbmeldung, AbschnittTitel: constVarianteKeyAbmeldung },
  { Key: constVarianteKeySonderfall, RadioButtonLabel: constVarianteKeySonderfall, AbschnittTitel: constVarianteKeySonderfall }
];  

export const numericFieldsRM: string[] = [
  "KuenftigeMengeStundenmittel",
  "KuenftigeMengeStundenmittel",
  "KuenftigeMengeMin",
  "KuenftigeMengeMax",
  "BisherigeMengeStundenmittel",
  "BisherigerAnschlussNWDN"
];

export const FormFieldsRM: IFormField[] = [
  { 
    Id:    "Medium",
    Label:     "Medium",
    FieldType: constFTypeDropdown,
    required:  true,
  },
  { 
    Id:    "MediumKurzzeichen",
    Label:     "Medium (Kurzzeichen)",
    FieldType: constFTypeDropdown,
    required:  true,
  },
  { 
    Id:    "Normaldruck",
    Label:     "Betriebsdruck (barü)",
    FieldType: constFTypeDropdown,
    required:  true,
  },
  { 
    Id:    "ANMStellenBezeichnung",             
    Label:     "Abnahmestelle / Messstellen-Bezeichnung",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsAenderungOrAbmeldung
  },
  { 
    Id:    "BisherigeMengeStundenmittel",             
    Label:     "bisherige Abnahmemenge (Stundenmittel)",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsAenderungOrAbmeldung
  },
  { 
    Id:    "BisherigerAnschlussNWDN",             
    Label:     "Bisheriger Anschluss (Nennweite DN)",
    FieldType: constFTypeTextField,
    required:  false,
    used:      commonCode.VarianteIsAenderungOrAbmeldung
  },
  { 
    Id:    "KuenftigeMengeStundenmittel",             
    Label:     "künftige Abnahmemenge (Stundenmittel)",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsErstAnforderungOrAenderung
  },
  { 
    Id:    "KuenftigeMengeMin",             
    Label:     "künftige Abnahmemenge (Min-Wert)",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsErstAnforderungOrAenderung
  },
  { 
    Id:    "KuenftigeMengeMax",             
    Label:     "künftige Abnahmemenge (Max-Wert)",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsErstAnforderungOrAenderung
  },
  { 
    Id:    "SonderfallsBeschreibung",             
    Label:     "Beschreibung des Sonderfalls",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.VarianteIsSonderfall
  },
  {        // Exists also is StromNetz, but with different Label
    Id:    "BemerkungAntragsteller",                   
    Label:     "Verwendungszweck (Kurzbeschreibung)",
    FieldType: constFTypeTextField,
    required:  false,
  },
  {
    Id:    "Betriebsweise", 
    Label:     "Betriebsweise",
    FieldType: constFTypeDropdown,
    required:  true,
  },
  { 
    Id:    "ZykluszeitenZyklusdauer",             
    Label:     "Zykluszeiten / Zyklusdauer",
    FieldType: constFTypeTextField,
    required:  true,
    used:      commonCode.BetriebsweiseIsDiskontinuierlich
  }
];